<nova-detail-toolbar [showBackButton]="false" title="Change Summary">
</nova-detail-toolbar>

<div class="table-container">
    <mat-card>

        <table class="nova__table">
            <colgroup>
                <col span="1" style="width: 30%;">
                <col span="1" style="width: 25%;">
                <col span="1" style="width: 25%;">
                <col span="1" style="width: 20%;">
             </colgroup>
            <thead>
                <tr class="header-row">
                    <th id="change" class="mat-header-cell">Change</th>
                    <th id="oldValue" class="mat-header-cell">Old Value</th>
                    <th id="newValue" class="mat-header-cell">New Value</th>
                    <th id="effectiveDate" class="mat-header-cell">Effective Date</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let section of rateSections" class="mat-row">
                    <td colspan="3" class="mat-cell">
                        {{ section }}
                        <table class="mt-2 mb-2 rate-table">
                            <colgroup>
                                <col span="1" style="width: 38%;">
                                <col span="1" style="width: 34%;">
                                <col span="1" style="width: 28%;">
                            </colgroup>
                            <tr *ngFor="let rate of getRates(section)">
                                <td>{{ rate.payType }}</td>
                                <td>{{ rate.oldRate | currency:'$':'symbol':'1.0-2' }}</td>
                                <td [class.highlighted]="rate.newRate !== rate.oldRate">{{ rate.newRate | currency:'$':'symbol':'1.0-2' }}</td>
                            </tr>
                        </table>
                    </td>
                    <td class="mat-cell">
                        <mat-form-field appearance="outline" class="date-input" *ngIf="isBillSection(section)">
                            <input matInput [matDatepicker]="picker" [formControl]="startDateControl" (dateChange)="toFormattedDate($event)" [min]="minDate" [max]="maxDate">
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                            <mat-error *ngIf="startDateControl.hasError('matDatepickerMax') || startDateControl.hasError('matDatepickerMin')">Date is outside the contract start and end dates</mat-error>
                        </mat-form-field>
                    </td>
                </tr>
                <tr *ngFor="let section of ruleSections" class="mat-row">
                    <td colspan="3" class="mat-cell">
                        {{ section }}
                        <table class="mt-2 mb-2 rate-table">
                            <colgroup>
                                <col span="1" style="width: 38%;">
                                <col span="1" style="width: 34%;">
                                <col span="1" style="width: 28%;">
                            </colgroup>
                            <tr *ngFor="let rule of getRates(section)">
                                <td>{{ rule.payType }}</td>
                                <td>{{ rule.oldRate }}</td>
                                <td [class.highlighted]="rule.newRate !== rule.oldRate">{{ rule.newRate }}</td>
                            </tr>
                        </table>
                    </td>
                    <td class="mat-cell"></td>
                </tr>
            </tbody>
        </table>
    </mat-card>
    <div class="mt-2">
        <button color="primary"
                mat-raised-button
                (click)="saveChanges()"
                class="mr-2"
                [disabled]="startDateControl.invalid || pendingSave">SAVE CHANGES</button>
        <button color="default"
                mat-raised-button
                (click)="close()">CLOSE</button>
    </div>
</div>
